import React from 'react';

const OnlinePayment = () => {
  return (
    <div>
      OnlinePayment
      OnlinePayment
    </div>
  );
}

export default OnlinePayment;
